import React from 'react';
import { FormGroup, InputGroup } from '@blueprintjs/core';
import { ErrorMessage } from 'formik';
import ErrorWrapper from 'components/forms/components/error-wrapper';
import shortid from 'shortid';

const FormTextGroup = props => {
	const inputID = shortid.generate();
	const styles = typeof props.style !== 'undefined' ? props.style : {};
	return (
		<FormGroup
			inline={false}
			label={props.label}
			labelFor={`text-input-${inputID}`}
			labelInfo={props.requiredLabel && '(required)'}
			className={props.class || ''}
			style={styles}
		>
			<InputGroup
				id={`text-input-${inputID}`}
				onChange={props.handleChange}
				onBlur={props.handleBlur}
				name={props.name}
				value={props.value || ''}
				type={props.inputType || 'text'}
				leftIcon={props.leftIcon}
				autoComplete={props.autocomplete || ''}
				disabled={props.disabled || false}
				maxLength={200}
				minLength={1}
				style={props.maxWidth && { maxWidth: props.maxWidth }}
			/>
			<ErrorMessage
				name={props.name}
				render={msg => <ErrorWrapper>{msg}</ErrorWrapper>}
			/>
		</FormGroup>
	);
};

export default FormTextGroup;
